import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CalculationState {
    loading: boolean;
    error: string | undefined;
}

export const initialState: CalculationState = {
    loading: false,
    error: "",
};
export const fetchTemplateCalculations = createAction(
  "jetlift/calculations/fetchTemplateCalculations"
);
export const saveJetliftProject = createAction("jetlift/calculations/saveJetliftProject");
export const saveJetliftMainReportData = createAction("jetlift/calculations/saveJetliftMainReportData");
export const downloadJLMainReport = createAction<{ reportType?: string }>("jetlift/calculations/downloadJLMainReport");
export const emptyaction = createAction("jetlift/calculations/emptyaction");
export const copyJetliftProject = createAction("jetlift/calculations/copyJetliftProject");

const JetliftCalculationSlice = createSlice({
    name: "jetlift/calculations",
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action?.payload;
        },
        setError(state, action: PayloadAction<string>) {
            state.error = action.payload;
        },
    },
});

export const {
    setLoading,
    setError,
} = JetliftCalculationSlice.actions;
export default JetliftCalculationSlice.reducer;
